module.exports = __webpack_public_path__ + "img/logo.610b1ec4.png";